import { useEffect } from 'react'
import { StyledVehicleDetailImage } from './VehicleDetailImage.style'
export const DSIImage = ({ mediaUploadId }) => {
  useEffect(() => {
    ;(window as any).SVFyusion.addViewer(mediaUploadId, `fyuse_viewer_${mediaUploadId}`)
  }, [mediaUploadId])

  return <StyledVehicleDetailImage id={`fyuse_viewer_${mediaUploadId}`}></StyledVehicleDetailImage>
}
